import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Visibility from '@material-ui/icons/Visibility';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import KobooRoundInput from '../../constants/KobooRoundInput.css';
import KobooButton from '../Layout/KobooButton';
import styles from '../../constants/stylesDefault';
import { postUserRenter } from '../../store/users/actions';
import Loader from '../Layout/Loader';
import * as routes from '../../constants/routes';
import { auth } from '../../firebase';
import Spinner from '../Layout/Spinner';
import { handleError } from '../../store/infos/actions';


const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  firstname: '',
  lastname: '',
  mobile: '',
  password: '',
  confirmPassword: '',
  showPassword: false,
};

export class InviteRenterForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }
  static getDerivedStateFromProps(props) {
    if (props.history.location) {
      return ({ email: props.history.location.search.replace('?mail=', '')});
    }
    return null;
  }



  //Handler

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  onSubmit = (event) => {
    const {
      email,
      password,
      firstname,
      lastname,
      mobile,
    } = this.state;
    this.props.postUserRenter(
      this.props.history.location.pathname.replace('/invite/', ''),
      {
        email,
        password,
        firstname,
        lastname,
        mobile
      }).then(() => {
      auth.doSignInWithEmailAndPassword(email, password)
        .then(() => {
          this.props.history.push(routes.DASHBOARD);
        })
        .catch((error) => {
          this.props.handleError(error);
        });
      })
      .catch((error) => {
        this.props.handleError(error);
      });
    event.preventDefault();
  };

  render() {
    const {
      email,
      password,
      confirmPassword,
      firstname,
      lastname,
      mobile
    } = this.state;
    const isInvalid =
      password !== confirmPassword ||
      email === '' ||
      password === '';

    let inviteForm;
    if (this.props.pending) {
      inviteForm = <Loader/>;
    } else {
      inviteForm = <form onSubmit={this.onSubmit} style={styles.center}>
        <Input
          style={KobooRoundInput.round}
          placeholder="Mot de passe"
          id="signin-password"
          type={this.state.showPassword ? 'text' : 'password'}
          value={password}
          onChange={event => this.setState(byPropKey('password', event.target.value))}
          disableUnderline={true}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                id="show-signin-password"
                aria-label="Toggle password visibility"
                onClick={this.handleClickShowPassword}
                onMouseDown={this.handleMouseDownPassword}
              >
                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        <Input
          style={KobooRoundInput.round}
          placeholder="Confirmer"
          id="confirm-password"
          type={this.state.showPassword ? 'text' : 'password'}
          value={confirmPassword}
          onChange={event => this.setState(byPropKey('confirmPassword', event.target.value))}
          disableUnderline={true}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                id="show-confirm-password"
                aria-label="Toggle password visibility"
                onClick={this.handleClickShowPassword}
                onMouseDown={this.handleMouseDownPassword}
              >
                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        <TextField
          style={KobooRoundInput.round}
          placeholder="Nom"
          id="profile-lastname"
          type="text"
          onChange={event => this.setState(byPropKey('lastname', event.target.value))}
          margin="normal"
          value={lastname}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <TextField
          style={KobooRoundInput.round}
          placeholder="Prénom"
          id="profile-firstname"
          type="text"
          onChange={event => this.setState(byPropKey('firstname', event.target.value))}
          margin="normal"
          value={firstname}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <TextField
          style={KobooRoundInput.round}
          placeholder="Téléphone"
          id="profile-mobile"
          type="text"
          onChange={event => this.setState(byPropKey('mobile', event.target.value))}
          margin="normal"
          value={mobile}
          InputProps={{
            disableUnderline: true,
          }}
        />
        <KobooButton disabled={isInvalid} type="submit">
          {this.props.sending ?
            <Spinner style={{ parent: { margin: '4px auto 0' }, child: {} }}/> : 'Créer'}
        </KobooButton>
      </form>;
    }

    return (
      <div>
        { inviteForm }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    pending: state.users.pending,
    sending: state.users.sending,
    users: state.users.content
  };
}

export default connect(mapStateToProps, { postUserRenter, handleError })(InviteRenterForm);



// WEBPACK FOOTER //
// ./src/components/InviteRenterForm/InviteRenterForm.jsx